import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import {Md5} from 'ts-md5/dist/md5';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import { GlobalVariable } from '../global';
import { LoginService } from '../services/login.service';
@Injectable()

export class AppraisalService{

   // BASE_URL = 'http://localhost:1234';
    private BASE_URL = GlobalVariable.BASE_URL; 
   
    

    constructor( private http : Http ,private router: Router, private ls : LoginService){}
    
    getSelfInfo()
    {
    
        return this.http.get(this.BASE_URL + '/appraisal/selfUser', this.ls.tokenHeader).map(res => res.json());
    }

    setSelfAppraisalData(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/selfAppraisalData', userData, this.ls.tokenHeader).map(res => res.json());
    }
    getSelfAppraisalData(appraisal_year)
    {
        //console.log(appraisal_year);
         return this.http.post(this.BASE_URL + '/appraisal/getSelfAppraisalDataList', {appraisal_year:appraisal_year},this.ls.tokenHeader).map(res => res.json());
    }
    getEmployeeAndL2(emplyoeeCodeData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/getEmployeeAndL2DD', emplyoeeCodeData, this.ls.tokenHeader).map(res => res.json());
    }
    setL2Code(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/setL2EmployeeCode', userData, this.ls.tokenHeader).map(res => res.json());
    }
    getFormInfo(form_id)
    {
         return this.http.post(this.BASE_URL + '/appraisal/formInfo', form_id, this.ls.tokenHeader).map(res => res.json());
    }
    setL2CommentData(l2comment)
    {
         return this.http.post(this.BASE_URL + '/appraisal/setl2Comment', l2comment, this.ls.tokenHeader).map(res => res.json());
    }
    setL2GradData(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/setl2Grad', userData, this.ls.tokenHeader).map(res => res.json());
    }
    setL4GradData(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/setl4Grad', userData, this.ls.tokenHeader).map(res => res.json());
    }
    getNSUUser(appraisal_year)
    {
         return this.http.post(this.BASE_URL + '/appraisal/getAllNsuUser',{appraisal_year:appraisal_year}, this.ls.tokenHeader).map(res => res.json());
    }
    getNsuAndL2(emplyoeeCodeData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/getNsuAndL2DD', emplyoeeCodeData, this.ls.tokenHeader).map(res => res.json());
    }
    setNsuL2Code(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/setL2NusCode', userData, this.ls.tokenHeader).map(res => res.json());
    }
    getNusInfo(emplyoeeCodeData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/getNusUserInfo',emplyoeeCodeData, this.ls.tokenHeader).map(res => res.json());
    }
    setNusAppraisalData(userData)
    {
        return this.http.post(this.BASE_URL + '/appraisal/setNusAppraisal',userData, this.ls.tokenHeader).map(res => res.json());
    }
    getSelfAppraisalArchieve()
    {
        return this.http.get(this.BASE_URL + '/appraisal/getSelfAppraisalArchieve', this.ls.tokenHeader).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/services/appraisal.service.ts